<div
  class="button-wrapper"
  [class.button-wrapper--selected]="config.isSelected"
  matRipple
  (click)="select()"
>
  <ng-content></ng-content>
</div>
